import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NewFolderComponent } from './new-folder.component';
import { NewFolderService } from './new-folder.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../modules/material.module';

@NgModule({
  imports: [
    FlexLayoutModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [NewFolderComponent],
  declarations: [NewFolderComponent],
  providers: [NewFolderService],
  entryComponents: [NewFolderComponent]
})
export class NewFolderModule { }



// WEBPACK FOOTER //
// ./src/app/core/new-folder/new-folder.module.ts